import { Button, colors } from '@spritz-finance/ui'
import React, { useState } from 'react'
import { DIRECT_PAY_OPENED_EVENT } from '../../../../analytics/events'
import { useAnalytics } from '../../../../context/useAnalytics'
import { AccountProvider } from '../../../../graphql/generated/graphql'
import { useWalletDialog } from '../../../../web3/connectDialog/WalletConnectDialogProvider'
import { useWeb3Connection } from '../../../../web3/Web3Provider'
import { DirectPayType } from '../../../bills/components/directPay/context/DirectPayContext'
import { DirectPayDialog } from '../../../bills/components/directPay/DirectPayDialog'
import { BankAccount } from '../BankAccounts'

type DirectPayButtonProps = {
    account: BankAccount
    disabled?: boolean
    isPayOthers?: boolean
}

export const PaymentButton: React.VFC<DirectPayButtonProps> = ({
    account,
    disabled = false,
    isPayOthers = false,
}) => {
    const { connected } = useWeb3Connection()
    const { openWalletConnectDialog } = useWalletDialog()
    const { trackAnalyticsEvent } = useAnalytics()
    const [paymentDialog, setDirectPayDialogOpen] = useState(false)

    const handleOffRamp = () => {
        trackAnalyticsEvent(DIRECT_PAY_OPENED_EVENT, {
            type: DirectPayType.OffRamp,
        })
        if (connected) {
            setDirectPayDialogOpen(true)
        } else {
            openWalletConnectDialog(() => setDirectPayDialogOpen(true))
        }
    }

    return (
        <>
            <Button.CTA
                variant="gradient"
                onClick={handleOffRamp}
                color={colors.brand}
                disabled={disabled}
            >
                {isPayOthers ? 'Pay with crypto' : 'Off-ramp crypto'}
            </Button.CTA>

            <DirectPayDialog
                title={isPayOthers ? 'Spritz Pay' : 'Off-ramp crypto'}
                type={DirectPayType.OffRamp}
                open={paymentDialog}
                onClose={() => setDirectPayDialogOpen(false)}
                account={{
                    accountId: account.id,
                    provider: AccountProvider.Checkbook,
                    name: account.name,
                    ownedByUser: account.ownedByUser,
                }}
                fullAccount={account}
            />
        </>
    )
}
